var _a;
import { Focus_Request_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Focus_Request_Type.DisputingACharge] = 'Disputing a charge',
    _a[Focus_Request_Type.Other] = 'Other',
    _a[Focus_Request_Type.RequestingInformationAboutMyCoverage] = 'Requesting information about my coverage',
    _a[Focus_Request_Type.SubmittingOutOfNetworkForReimbursement] = 'Submit an out-of-network claim for reimbursement',
    _a);
export var FocusRequestTypeEnum = {
    name: 'Focus_Request_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
